import React from 'react';
import styled from 'styled-components';
import { useSaved } from '../context/SavedContext';
import { useExperiences } from '../context/ExperiencesContext';
import AuthPanel from './AuthPanel';
import BentoGrid from './BentoGrid';

const Container = styled.div`
  min-height: 100vh;
  padding: 20px;
`;

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #ff00aa, #00f5ff);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const Subtitle = styled.p`
  color: rgba(255, 255, 255, 0.7);
  margin-top: 8px;
`;

const BackButton = styled.button`
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 8px 16px;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;

  &:hover {
    border-color: rgba(255, 255, 255, 0.4);
  }
`;

const EmptyState = styled.p`
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  font-size: 1.1rem;
  margin-top: 60px;
`;

function SavedPage({
  onBack,
  onExperienceClick,
  onNavigateToSaved,
  onNavigateToRecommendations,
  onNavigateToCreate,
  onNavigateToMyUploads,
  onNavigateToReview,
  canCreatePost,
  canReview
}) {
  const { savedIds, requestSave, isSaved } = useSaved();
  const { getExperienceById } = useExperiences();
  const experiences = savedIds
    .map((id) => getExperienceById(id))
    .filter(Boolean);

  return (
    <Container>
      <TopBar>
        <BackButton type="button" onClick={onBack}>
          ← Back
        </BackButton>
        <AuthPanel
          onNavigateToSaved={onNavigateToSaved}
          onNavigateToRecommendations={onNavigateToRecommendations}
          onNavigateToCreate={onNavigateToCreate}
          onNavigateToMyUploads={onNavigateToMyUploads}
          onNavigateToReview={onNavigateToReview}
          canCreatePost={canCreatePost}
          canReview={canReview}
        />
      </TopBar>
      <Header>
        <Title>Saved</Title>
        <Subtitle>Your saved experiences</Subtitle>
      </Header>
      {experiences.length === 0 ? (
        <EmptyState>No saved experiences yet. Save some from the home page!</EmptyState>
      ) : (
        <BentoGrid
          experiences={experiences}
          onExperienceClick={onExperienceClick}
          showSaveButton
          isSaved={isSaved}
          onSaveClick={requestSave}
        />
      )}
    </Container>
  );
}

export default SavedPage;
